// extracted by mini-css-extract-plugin
export var copyableField = "_m4-4";
export var customerBadge = "_m4-0";
export var customerInfoTitle = "_m4-2";
export var details = "_m4-1";
export var dropdownContainer = "_m4-5";
export var dropdownImage = "_m4-6";
export var editAssigneeForm = "_m4-a";
export var editButton = "_m4-3";
export var email = "_m4-7";
export var hidden = "_m4-d";
export var input = "_m4-8";
export var saveButton = "_m4-b";
export var shopifyIcon = "_m4-c";
export var suggestionBadge = "_m4-e";
export var suggestionText = "_m4-f";
export var username = "_m4-9";